import {
    Box,
    Button,
    CheckBox,
    CheckBoxGroup,
    Form,
    FormField,
    Heading,
    Layer,
    RadioButtonGroup,
    Text,
    TextInput
} from 'grommet';
import React, {useEffect, useState} from "react";
import ApiService from "../../services/ApiService";
import ErrorService from "../../services/ErrorService";
import Highcharts from 'highcharts'
import HighchartsExporting from 'highcharts/modules/exporting'
import {useDispatch, useSelector} from "react-redux";
import Helpbar from "../../components/Helpbar/Helpbar";
import AuthService from "../../services/AuthService";
import ThemeService from "../../services/ThemeService";
import SavingEicHelp from "./SavingEicHelp";
import SavingEicPdfExport from "./SavingEicPdfExport";
import FormatService from "../../services/FormatService";
import CalcDetailService from "../../services/CalcDetailService";
import {UgSpinner} from "../../components/Spinner/UgSpinner";
import {UgPdfIcon} from "../../components/Icons/UgPdfIcon";
import {UgHelpIcon} from "../../components/Icons/UgHelpIcon";
import * as Icons from "grommet-icons";
import CalcPinService from "../../services/CalcPinService";
import SavedStatesService from "../../services/SavedStatesService";
import AddEditSavedStatesModal from "../SavedStates/AddEditSavedStatesModal";
import {toast} from "react-toastify";
import LoadSavedStatesModal from "../SavedStates/LoadSavedStatesModal";


export const ACCOUNT_CIELOVY_UCET = {id: 2, label: "Cieľový účet", output: "Výstup cieľového účtu"};
export const ACCOUNT_MANAZOVANY_INVESTICNY_UCET ={id: 4, label: "Manažovaný investičný účet", output: "Výstup manažovaného investičného účtu"}
export const ACCOUNT_INVESTICNY_UCET =  {id: 1, label: "Investičný účet", output: "Výstup investičného účtu"}
export const ACCOUNT_MANAZOVANY_CIELOVY_UCET = {id: 6, label: "Manažovaný cieľový účet", output: "Výstup manažovaného cieľového účtu"}

const ACCOUNTS = [
    ACCOUNT_CIELOVY_UCET,
    ACCOUNT_MANAZOVANY_CIELOVY_UCET,
    ACCOUNT_INVESTICNY_UCET,
    ACCOUNT_MANAZOVANY_INVESTICNY_UCET
]

export const ACCOUNTS_MAP = Object.fromEntries(
    ACCOUNTS.map(acc => [acc.id, acc])
);

function SavingEic(props) {
    const state = useSelector((state) => state);
    const calcStateKey = 'SavingEic';
    const calcStateVersion = 6
    const [fundsError, setFundsError] = useState('');
    const [fundsSum, setFundsSum] = useState(0);

    HighchartsExporting(Highcharts);

    const defaultValues = {
        title: 'EIC nákladovosť',
        mode: ACCOUNTS[0].id,

        period: 15,
        periodUnits: 'y',

        isMixEnabled: false,
        others: 0,
        othersCount: 0,
        cashFundsCount: 0,
        cashPayment: 0,
        etfPayment: 100,
        etfFundsCount: 1,
        equitiesCount: 0,
        equities: 0,
        bondsFundsCount: 0,
        bonds: 0,
        mixedFundsCount: 0,
        mixed: 0,
        managementFee: 0,
        monthsForFee: 1,
        payment: 100,
        revenue: 6,
        startFee: 3,
        success_fee: 0,
        success_fee_base_rate: 0,
        openHelp: false,
        pdfGenerating: false,
    };
    const valuesInitialState = CalcDetailService.pluckInitialState(calcStateKey, 'values', defaultValues, calcStateVersion);
    const resultInitialState = CalcDetailService.pluckInitialState(calcStateKey, 'result', null, calcStateVersion);

    const [values, setValues] = useState(valuesInitialState);
    const [result, setResult] = useState(resultInitialState);
    const [activeRequest, setActiveRequest] = useState(false);
;

    function saveCalcDetail(values, result){
        const calcDetailState = {
            values:values,
            result:result,
        };
        if (window.debug){
            console.log('Saving ', calcStateKey, calcDetailState);
        }
        CalcDetailService.setStateForCalc(calcStateKey, calcDetailState, calcStateVersion);
    }

    useEffect(() => {
        saveCalcDetail(values, result);
        // eslint-disable-next-line
    }, [values, result]);

    const fundRows = [
        { name: "ETF", key: "etfPayment", countKey: "etfFundsCount", show: true },
        { name: "Akciové", key: "equities", countKey: "equitiesCount", show: [ACCOUNT_MANAZOVANY_CIELOVY_UCET.id, ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id] },
        { name: "Dlhopisové", key: "bonds", countKey: "bondsFundsCount", show: [ACCOUNT_MANAZOVANY_CIELOVY_UCET.id, ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id] },
        { name: "Zmiešané", key: "mixed", countKey: "mixedFundsCount", show: [ACCOUNT_MANAZOVANY_CIELOVY_UCET.id, ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id] },
        { name: "Peňažné", key: "cashPayment", countKey: "cashFundsCount", show: true },
        { name: "Ostatné fondy", key: "others", countKey: "othersCount", show: [ACCOUNT_CIELOVY_UCET.id, ACCOUNT_INVESTICNY_UCET.id] },
    ];

    const recalcFundsSum = (values) => {
        let total = 0;
        total += Number(values.etfPayment || 0);
        total += Number(values.cashPayment || 0);
        total += Number(values.equities || 0);
        total += Number(values.bonds || 0);
        total += Number(values.mixed || 0);
        total += Number(values.others || 0);

        setFundsSum(total);
    };

    const resetInvisibleFunds = (nextValue) => {
        // Základne, viditeľné pre všetky typy účtov
        if (nextValue.mode === ACCOUNT_MANAZOVANY_CIELOVY_UCET.id || nextValue.mode === ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id) {
            // Viditeľné: ETF, equities, bonds, mixed, cash
            nextValue.others = 0;
        } else if (nextValue.mode === ACCOUNT_CIELOVY_UCET.id || nextValue.mode === ACCOUNT_INVESTICNY_UCET.id) {
            // Viditeľné: ETF, cash, others
            nextValue.equities = 0;
            nextValue.bonds = 0;
            nextValue.mixed = 0;
        }

        return nextValue;
    };

    function onFormSubmit(values){
        const periodMonths = values.periodUnits === 'm' ? values.period : values.period*12;

        const account = {};
        switch(values.mode){
            case ACCOUNT_CIELOVY_UCET.id:
                account.type = "target"
                account.monthsForFee = Number(values.monthsForFee)
                account.etfPayment = values.etfPayment
                account.cashPayment = values.cashPayment
                account.otherPayment = values.others
                break;
            case ACCOUNT_INVESTICNY_UCET.id:
                account.type = "investment"
                account.etfPayment = values.etfPayment
                account.cashPayment = values.cashPayment
                account.otherPayment = values.others
                break;
            case ACCOUNT_MANAZOVANY_CIELOVY_UCET.id:
                account.type = "managedTarget"
                account.monthsForFee = values.monthsForFee
                account.managementFee = values.managementFee
                account.successFee = values.success_fee
                account.successFeeBaseRate = values.success_fee_base_rate
                account.etfPayment = values.etfPayment
                account.stockPayment = values.equities
                account.bondPayment = values.bonds
                account.mixedPayment = values.mixed
                account.cashPayment = values.cashPayment
                break;
            case ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id:
                account.type = "managedInvestment"
                account.managementFee = values.managementFee
                account.successFee = values.success_fee
                account.successFeeBaseRate = values.success_fee_base_rate
                account.etfPayment = values.etfPayment
                account.stockPayment = values.equities
                account.bondPayment = values.bonds
                account.mixedPayment = values.mixed
                account.cashPayment = values.cashPayment
                account.etfFundsCount = values.etfFundsCount
                account.stockFundsCount = values.equitiesCount
                account.bondFundsCount = values.bondsFundsCount
                account.mixedFundsCount = values.mixedFundsCount
                account.cashFundsCount = values.cashFundsCount
                break;
        }
        const reqData = {
            periodInMonths: periodMonths,
            revenue: values.revenue,
            startFee: values.startFee,
            payment: values.payment,
            account
        };

        setActiveRequest(true);
        ApiService.call('post', '/v2/savings/eicCost', reqData)
            .then((res) => {
                    setResult(res);
                    setActiveRequest(false);
                },
                (error) => {
                    setActiveRequest(false);
                    ErrorService.fromApi(error);
                });
    }

    function onExportPdfModeFormSubmit(){
        exportPdf();
    }

    const pinKey = 'eic-nakladovost';
    const dispatch = useDispatch();
    function togglePinCalc(key){
        if (CalcPinService.isCalcPinned(key)){
            CalcPinService.unpinCalc(key).then((res)=>{
                CalcPinService.setStateData(res);
                dispatch({type:'calcpin/save'});
            });
        } else {
            CalcPinService.pinCalc(key).then((res)=>{
                CalcPinService.setStateData(res);
                dispatch({type:'calcpin/save'});
            });
        }
    }

    function exportPdf(){
        setValues(Object.assign({}, values, {pdfGenerating: true}));
        const data = {
            pool: ThemeService.getTheme().pool,
            title: values.title,
            subtitle: '',
            filename: 'calc-export',
            content: SavingEicPdfExport({values:values,result:result,chart:null}),
        };
        fetch(`${process.env.REACT_APP_INTRANET_API_URL}/ugcalculator/generatePdf`,{
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + AuthService.getAccessToken()
            },
            body: data ? JSON.stringify(data) : null
        })
            .then(res => res.blob())
            .then(res => {
                const file = window.URL.createObjectURL(res);
                window.open(file, '_blank');
                setValues(Object.assign({}, values, {pdfGenerating: false}));
            })
            .catch(console.error);
    }


    const [showModal, setShowModal] = useState(false);
    function onAddEditSaveStateModalClose(res=null){
        if (res){
            setSavedState(res);
            setValues(res.contents.state);
            onFormSubmit(res.contents.state);
        }
        setShowModal(false);
    }

    const [savedState, setSavedState] = useState(null);
const [showLoadModal, setShowLoadModal] = useState(false);
    function onLoadSaveStateModalClose(res=null){
        setShowLoadModal(false);
    }
    useEffect(() => {
        if (props && props.match && props.match.params && props.match.params.id){
            SavedStatesService.getDetail(props.match.params.id)
                .then((res) => {
                        if (!res || !res.contents || !res.contents.state){
                            setSavedState(null);
                            if (window.debug) {
                                console.log('Neviem otvoriť stav, pretože dáta sú neplatné.', savedState, calcStateVersion);
                            }
                            return false;
                        }
                        if (res.contents && res.contents.version && calcStateVersion){
                            if (res.contents.version !== calcStateVersion){
                                setSavedState(null);
                                if (window.debug) {
                                    console.log('loadSavedState', 'zla verzia ulozenych dat, neviem otvorit', res, calcStateVersion);
                                }
                                return false;
                            }
                        }
                        toast.success('Modelovanie bolo načítané', {
                            position: "top-center",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        setSavedState(res);
                        setValues(res.contents.state);
                        recalcFundsSum(values);
                        onFormSubmit(res.contents.state);
                    },
                    (error) => {
                        setValues(Object.assign({}, values, {activeRequest: false}));
                        ErrorService.fromApi(error);
                    });
        }
        recalcFundsSum(values);
    }, [props.match.params.id]);

    return (
        <Box flex={false} margin={{'horizontal': 'small'}}>
            <Helpbar open={values.openHelp} closeaction={ () => setValues(Object.assign({}, values, {openHelp: false})) }><SavingEicHelp/></Helpbar>

            <Box pad={'small'} direction={'row-responsive'} align={'center'} justify={'between'}>
                <Heading>{values.title} <a style={{cursor:'pointer'}} onClick={()=>{togglePinCalc(pinKey)}}><Icons.Pin color={CalcPinService.isCalcPinned(pinKey) ? 'active' : 'dark'} /></a></Heading>
                <Box direction={'row'}>
                    <LoadSavedStatesModal show={showLoadModal} pinkey={pinKey} closeaction={(res)=>onLoadSaveStateModalClose(res)}>
                        <Button margin={{right:'xsmall'}} size={'small'} secondary label={<Icons.Catalog />} onClick={()=>setShowLoadModal(true)} />
                    </LoadSavedStatesModal>
                    <AddEditSavedStatesModal show={showModal}
                                             closeaction={(res)=>onAddEditSaveStateModalClose(res)}
                                             state={values}
                                             version={calcStateVersion}
                                             savedState={savedState}
                                             pinkey={pinKey}>
                        <Button margin={{right:'xsmall'}} size={'small'} secondary label={<Icons.Save />} onClick={()=>setShowModal(true)} />
                    </AddEditSavedStatesModal>
                    <Button margin={{right:'xsmall'}} size={'small'} secondary label={values.pdfGenerating ? <UgSpinner /> : <UgPdfIcon />} disabled={!result && !values.pdfGenerating} onClick={()=>{onExportPdfModeFormSubmit()}} />
                    <Button margin={'none'} size={'small'} secondary label={<UgHelpIcon />} onClick={()=>{setValues(Object.assign({}, values, {openHelp: true}))}} />
                </Box>
            </Box>

           

            <Box flex={false} pad={'medium'} round={'small'} border={true} background={'white'}>
                <Form
                    value={values}
                    onChange={nextValue => {
                        // Toggle isMixEnabled bol vypnutý
                        if (values.isMixEnabled === true && nextValue.isMixEnabled === false) {

                            nextValue.etfPayment = defaultValues.etfPayment;
                            nextValue.equities = defaultValues.equities;
                            nextValue.bonds = defaultValues.bonds;
                            nextValue.others = defaultValues.others;
                            nextValue.mixed = defaultValues.mixed;
                            nextValue.cashPayment = defaultValues.cashPayment;

                            nextValue.etfFundsCount = defaultValues.etfFundsCount;
                            nextValue.equitiesCount = defaultValues.equitiesCount;
                            nextValue.bondsFundsCount = defaultValues.bondsFundsCount;
                            nextValue.mixedFundsCount = defaultValues.mixedFundsCount;
                            nextValue.cashFundsCount = defaultValues.cashFundsCount;
                        }

                        if (values.mode!==nextValue.mode){
                            // reset neviditeľných fondov pri zmene typu účtu
                            nextValue = resetInvisibleFunds(nextValue);
                            setResult(null);
                        }

                        setValues(nextValue);

                        recalcFundsSum(nextValue);
                        //dispatch({type:'calc/save', payload: {regularInvestment: nextValue}});
                    }}
                    onReset={() => {
                        let init = defaultValues;
                        init.mode = values.mode;
                        setValues(init);
                        setResult(null);
                        recalcFundsSum(init);
                        setFundsError('');
                    }}
                    onSubmit={({ value }) => {
                        if (fundsSum !== 100) {
                            setFundsError('Súčet fondov musí byť 100%');
                            return;
                        }
                        setFundsError('');
                        onFormSubmit(value);
                    }}
                >

                    <Box direction={'row-responsive'}>
                        <Box basis={'auto'} round={'xsmall'} margin={{bottom: 'large', top:'medium'}}>
                            <RadioButtonGroup direction={props.size==='small'? 'column' : 'row'} gap={'medium'} name="mode" required={true} options={ACCOUNTS.map(function(a){
                                return {value: a.id, label: a.label}
                            })} />
                        </Box>
                    </Box>

                    <Box direction={'row'} alignItems={'center'} margin={{bottom: 'medium'}} wrap>
                        <Box basis={'auto'} direction={'row'} align={'center'}>
                            <FormField label="Výška vkladu (€)" width={'full'}>
                                <TextInput name="payment" type="number" step="0.01" required={true} />
                            </FormField>
                        </Box>

                        <Box basis={'auto'} direction={'row'} align={'center'}>
                            <FormField label="Výnos p.a. (%)" width={'full'}>
                                <TextInput name="revenue" type="number" step="0.01" required={true} />
                            </FormField>
                        </Box>

                        <Box basis={'auto'} direction={'row'} align={'center'}>
                            <FormField label="Vstupný poplatok (%)" width={'full'}>
                                <TextInput name="startFee" type="number" step="0.1" required={true} />
                            </FormField>
                        </Box>

            

                        {[ACCOUNT_CIELOVY_UCET.id, ACCOUNT_MANAZOVANY_CIELOVY_UCET.id].includes(values.mode) && <Box basis={'auto'} direction={'row'} align={'center'} >
                            <FormField label="Doba splácania poplatku (m)" width={'full'}>
                                <TextInput name="monthsForFee" type="number" step="1" required={true} />
                            </FormField>
                        </Box>}

                        {[ACCOUNT_MANAZOVANY_CIELOVY_UCET.id, ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id].includes(values.mode) && <Box basis={'auto'} direction={'row'} align={'center'}>
                            <FormField label="Management fee (%)" width={'full'}>
                                <TextInput name="managementFee" type="number" step="0.1" required={true} />
                            </FormField>

                            <FormField label="Success fee (%)" width={'full'}>
                                <TextInput name="success_fee" type="number" step="1" required={true} />
                            </FormField>
                        

                            <FormField label="Základná sadzba (%)" width={'full'}>
                                <TextInput name="success_fee_base_rate" type="number" step="0.10" required={true} />
                            </FormField>
					      

                        </Box>}

                        <Box direction={'row'} align={'center'} wrap>
                            <FormField label='Doba investovania' width={'auto'}>
                                <TextInput name="period" type="number" min="1" step="1" required={true} />
                            </FormField>
                            <RadioButtonGroup gap={'small'} margin={{left: 'small'}} width={'auto'} direction={'column'} name="periodUnits" options={[
                                {value: 'm',label: "Mesiacov"},
                                {value: 'y',label: "Rokov"},
                            ]} />
                        </Box>
                    </Box>

                    <Box margin={{vertical: 'small'}} direction={'row-responsive'} align={'start'}>
                        <Box basis={'auto'} direction={'column'} pad={'small'} align={'start'} border={true} round={'small'} background={'white'}>
                            <table className="table minimal-table">
                                <thead>
                                <tr>
                                    <td><CheckBox name="isMixEnabled" toggle={true} border={false} label="Vlastný pomer" /></td>
                                    <th>Rozdelenie fondov (%)</th>
                                    {values.mode == ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id && <th>Počet fondov</th>}
                                </tr>
                                </thead>
                                <tbody>
                                {fundRows
                                    .filter(row => row.show === true || (Array.isArray(row.show) && row.show.includes(values.mode)))
                                    .map(row => (
                                        <tr key={row.key}>
                                            <th className="text-right">{row.name}</th>
                                            <td>
                                                <TextInput name={row.key} type="number" step="1" disabled={!values.isMixEnabled} required />
                                            </td>
                                            {values.mode === ACCOUNT_MANAZOVANY_INVESTICNY_UCET.id && row.countKey && (
                                                <td>
                                                    <TextInput name={row.countKey} type="number" disabled={!values.isMixEnabled} required />
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                <tr>
                                    <th className="text-right">SPOLU</th>
                                    <td className="text-center"><b>{fundsSum} %</b></td>
                                    <td></td>
                                </tr>
                                {fundsError && (
                                    <tr>
                                        <th></th>
                                        <td colSpan={2} style={{ color: 'orange' }}>{fundsError}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </Box>
                    </Box>

                    <Box direction="row" gap="medium" margin={{top:'medium'}}>
                          
                        <Button type="submit" primary label="Vypočítať" disabled={activeRequest} />
                        <Button type="reset" label="Nastaviť predvolené" />
                    </Box>
                </Form>
            </Box>


            {result!==null &&
            <Box direction={props.size==='small'? 'column' : 'row'} margin={{vertical: 'medium'}} pad={'medium'} border={true} round={'small'} background={'white'} align={'start'} justify={'start'}>
                <Box pad={'medium'} margin={{right: 'small'}} border={true} round={'small'} background={'white'} width={'1/2'}>
                    <Heading level="3" margin={'none'}> {ACCOUNTS_MAP[Number(values.mode)]?.output}</Heading>
                    <div className="table-responsive">
                        <table className="table styled-table">
                            <tbody>
                            <tr>
                                <th>Hodnota investície na konci investičného horiznotu</th>
                                <td className="text-right"><b>{FormatService.round(result.endValue)}</b> €</td>
                            </tr>
                            <tr>
                                <th>Absolútny výnos</th>
                                <td className="text-right"><b>{FormatService.round(result.absolutProfit*100)}</b> %</td>
                            </tr>
                            <tr>
                                <th>Čistý výnos p.a.</th>
                                <td className="text-right"><b>{FormatService.round(result.profit*100)}</b> %</td>
                            </tr>
                            <tr>
                                <th>Návratnosť v mesiacoch</th>
                                <td className="text-right"><b>{FormatService.round(result.monthReturn)}</b> m</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Box>
                
                
            </Box>
            }  

        </Box>
    );
}

export default SavingEic;